export default __webpack_public_path__ + "static/Wallet_FET-bb0e824ef8ac49ce3714fde873021fbd.svg";